// =====================================
//	加入購物車跳出的視窗
//	@author: Gray
//	@time 2016 / 11 / 28
// =====================================

window.InifECMobileApp.directive('addCartResult', ['$rootScope', '$ngModal', '$timeout',
	function ($rootScope, $ngModal, $timeout) {

		var _dir = {};

		var controller = ['$scope', function($scope) {

            // ===============================
            //  開啟 modal
            // ===============================
            var openModal = function() {

            	$ngModal.openModal('add-cart-result-modal');
            }

            // ===============================
            //  關閉 modal
            // ===============================
            var closeModal = function() {

            	$ngModal.closeModal('add-cart-result-modal');
            }

            /*==========================
                Events
            ==========================*/            
            $scope.$on('OPEN_ADD_CART_RESULT_MODAL', function(event, data) {
                
            	openModal();
            });

            /*==========================
                Members
            ==========================*/

            /*==========================
                Methods
            ==========================*/

            /*==========================
                init
            ==========================*/
            
		}]

		_dir.restrict = "E";
		_dir.scope = true;
		_dir.templateUrl = "mobile/partials/modal/add_cart_result.html";
		_dir.controller = controller;

		return _dir;
	}]
);